import React from 'react'

import './index.scss'
import { mixUrl } from 'multiPublic'
import IconBtn from '../../../containers/VideoList/Image/video-btn-1.png'

const formatVideoDuration = (duration) => {
    if ((typeof duration !== 'number' && typeof duration !== 'string') || String(duration).trim() === '') return ''

    const durationSeconds = Number(duration)
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return ''

    const totalSeconds = Math.floor(durationSeconds)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    const timeParts = [minutes, seconds]

    if (hours > 0) timeParts.unshift(hours)

    return timeParts.map((part) => String(part).padStart(2, '0')).join(':')
}

export default (props) => {
    const {
        id, // id
        title, // 标题
        publishTime, // 时间
        coverPic, // 图片
        author, // 作者
        passportId, // 作者ID
        createdBy, // 作者ID
        duration // 播放时长（秒）
    } = props

    let imgUrl = ''
    try {
        const cover = typeof coverPic === 'string' ? JSON.parse(coverPic) : coverPic
        imgUrl = cover ? cover.pc || cover.video_pc || cover.m || '' : ''
    } catch (err) {
        imgUrl = ''
    }
    const videoDuration = formatVideoDuration(duration)
    const videoLink = mixUrl.main(`/video/detail/${id}/${publishTime}`)
    const authorId = passportId || createdBy

    return (
        <div className="video-detail-right-recommend-item">
            <a className="video-detail-right-recommend-item-left" href={videoLink} target="_blank" title={title}>
                <img className="video-detail-right-recommend-item-img" src={imgUrl} />
                <span className="video-detail-right-recommend-item-play">
                    <img src={IconBtn} alt="播放" />
                </span>
                {videoDuration && <span className="video-detail-right-recommend-item-duration">{videoDuration}</span>}
            </a>
            <div className="video-detail-right-recommend-item-right">
                <a className="video-detail-right-recommend-item-title" href={videoLink} target="_blank" title={title}>{title}</a>
                <div className="video-detail-right-recommend-item-text-box">
                    {authorId
                        ? <a
                            className="video-detail-right-recommend-item-text video-detail-right-recommend-item-author"
                            href={mixUrl.main(`/userCenter/${authorId}`)}
                            target="_blank"
                        >
                            {author}
                        </a>
                        : <span className="video-detail-right-recommend-item-text">{author}</span>}
                </div>
            </div>
        </div>
    )
}
